<template>
  <div>
    <p
      ref="root"
      :style="`
        white-space: pre-wrap;
        margin: 0;
        ${lines > 0 ? `
            display: -webkit-box; 
            -webkit-line-clamp: ${lines}; 
            -webkit-box-orient: vertical;
            overflow: hidden;
          ` : ''}
      `"
    >
      <template v-for="(item, i) in items">
        <span
          :key="i"
          v-if="typeof item === 'string'"
        >{{ item }}</span>
        <router-link 
          :key="i" 
          v-else-if="item.type === 'member'"
          class="fb-link"
          :to="item.to"
        >{{ item.text }}</router-link>
        <span 
          :key="i" 
          v-else-if="item.type === 'hashtag'"
          class="fb-link"
        >{{ item.text }}</span>
      </template>
    </p>
    <p v-if="lineClamped"
      class="ma-0 subtitle-1 primary--text"
      style="cursor: pointer;"
      @click="expanded = !expanded"
    >See {{ expanded ? 'Less' : 'More' }}</p>
  </div>
</template>

<script>
import FbMemberMixin from '../mixins/fb-member'

const regex = /(@[ugpHR]:\w+)/

export default {
  name: 'FbText',
  mixins: [FbMemberMixin],
  props: {
    text: String,
    maxLines: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      lineClamped: false,
      expanded: false
    }
  },
  mounted() {
    this.updateLineClamped()
  },
  updated() {
    this.updateLineClamped()
  },
  computed: {
    lines() {
      return this.expanded ? 0 : this.maxLines
    },
    items() {
      return this.text
        .replace(/#(\w+)/g, (_, tag) => `@H:${tag}`)
        .split(regex)
        .map((seg, i) =>{
          if (i % 2 === 0)
            return seg

          if (seg[1] === 'H')
            return {
              type: 'hashtag',
              text: `#${seg.substr(3)}`
            }
          
          const result = this.memberFromRef(seg)
          if (result == null)
            return seg

          return { 
            type: 'member',
            to: result.route, 
            text: this.name(result.member)
          }
        })
        .filter(e => e !== '')
    }
  },
  methods: {
    updateLineClamped() {
      const el = this.$refs.root
      this.lineClamped = el.offsetHeight < el.scrollHeight
    }
  }
}
</script>
